import React from 'react';
import { Grid as MuiGrid } from '@mui/material';

// Simple wrapper that removes the component prop to avoid TypeScript errors
const Grid = ({ component, ...props }: any) => {
  return <MuiGrid {...props} />;
};

export default Grid; 